import { Box, Flex, ReadonlyField, Text } from '@shared/components';

import { ReadonlyFormImagesInput } from '../readonly-form-images-input';

interface ReadonlyDoorInfoRowProps {
  label: string;
  numberOfDoors?: number;
  images?: string[];
}

export default function ReadonlyDoorInfoRow(props: Readonly<ReadonlyDoorInfoRowProps>) {
  const { label, numberOfDoors, images } = props;

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(6),
        justifyContent: 'space-between',
        [theme.breakpoints.down('desktop')]: {
          flexDirection: 'column',
        },
      })}
    >
      <Box sx={{ width: '320px' }}>
        <Text variant='body1' sx={{ fontWeight: 500 }}>
          {label}
        </Text>
      </Box>
      <Flex
        sx={(theme) => ({
          flex: 1,
          flexDirection: 'column',
          gap: theme.spacing(2),
        })}
      >
        <ReadonlyField content={numberOfDoors ? numberOfDoors.toString() : '-'} />
        <ReadonlyFormImagesInput images={images ?? []} label='แนบรูปภาพบริเวณประตูห้องสอบ' />
      </Flex>
    </Flex>
  );
}
